import React from 'react';
import { FaUser, FaBuilding, FaSync } from 'react-icons/fa';
import { anonymizeCompany } from '../../utils/demoMode';
import './DashboardHeader.scss';

const DashboardHeader = ({
    technician,
    client,
    isAdmin,
    isManager,
    onRefresh,
    refreshing
}) => {
    return (
        <div className="dashboard-header">
            <div className="dashboard-header__title">
                <img src="/PromptlyLogo.svg" alt="Promptly" className="logo" />
                <p>Manage customer communications and appointment confirmations</p>
            </div>

            <div className="dashboard-header__info">
                <div className="user-info">
                    <div className="user-details">
                        <span className="user-name">
                            <FaUser className="icon" />
                            {technician.name}
                        </span>
                        <span className="user-role">
                            {isAdmin ? 'Administrator' : isManager ? 'Manager' : 'Technician'}
                        </span>
                    </div>
                </div>

                <div className="client-info">
                    <span className="client-name">
                        <FaBuilding className="icon" />
                        {anonymizeCompany(client.name)}
                    </span>
                </div>

                <button
                    className="refresh-btn"
                    onClick={onRefresh}
                    disabled={refreshing}
                    title="Refresh data"
                >
                    <FaSync className={refreshing ? 'rotating' : ''} />
                </button>
            </div>
        </div>
    );
};

export default DashboardHeader;